import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "This study requires a fullscreen view", "Screenout", "User failed desktop fullscreen check", "app.error.fullscreen")